import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerDetailDto } from 'src/app/entity/customerDetailDto';
import { AddressDto } from 'src/app/entity/addressDto';
import { ContactDto } from 'src/app/entity/contactDto';
import { Router } from '@angular/router';
import { CustomerService } from '../customer.service';
import { CustomerDetailViewComponent } from '../customer-detail-view/customer-detail-view.component';
import { LicenceTableDto } from 'src/app/entity/licenceTableDto';
import { CustomerWizardDto } from 'src/app/entity/customerWizardDto';
import { SnackbarService } from 'src/app/snackbar/service/snackbar.service';

@Component({
  selector: 'app-customer-edit-view',
  templateUrl: './customer-edit-view.component.html',
  styleUrls: ['./customer-edit-view.component.scss'],
})
export class CustomerEditViewComponent implements OnInit {
  stepperIndex: number;

  isLinear = false;
  kundeninformationen: FormGroup;
  kontaktperson: FormGroup;

  entity: CustomerDetailDto;
  isNew: boolean;

  editMode: boolean;

  displayedColumns: string[] = ['name', 'licenceTo', 'buttons'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CustomerDetailDto,
    private formBuilder: FormBuilder,
    public router: Router,
    public dialogRef: MatDialogRef<CustomerDetailViewComponent>,
    private customerService: CustomerService,
    private snackbarService: SnackbarService
  ) {
    this.isNew = data.id === undefined;

    if (this.isNew) {
      this.entity = data;
      this.entity.address = new AddressDto();
      this.entity.address.contact = new ContactDto();
      this.entity.licences = new Array();
    } else {
      this.entity = data;
      console.log(this.entity.address);
      console.log(this.entity.licences);
    }
  }

  ngOnInit() {
    this.kundeninformationen = this.formBuilder.group({
      name: [this.entity.name, Validators.required],
      // logo: [this.entity.name, Validators.required],
      street: [this.entity.address.street, Validators.required],
      postalCode: [this.entity.address.postalCode, Validators.required],
      city: [this.entity.address.city, Validators.required],
      country: [this.entity.address.country, Validators.required],
    });
    this.kontaktperson = this.formBuilder.group({
      name: [this.entity.address.contact.name, Validators.required],
      email: [
        this.entity.address.contact.email,
        [Validators.required, Validators.email],
      ],
      phone: [this.entity.address.contact.phone, Validators.required],
    });
  }

  onSubmit(): void {
    console.log(this.kundeninformationen.value);
    console.log(this.kontaktperson.value);
  }

  save(): void {
    let valid = true;
    this.entity.licences.forEach((licence) => {
      if (
        licence.name === undefined ||
        licence.name === '' ||
        licence.to === undefined
      ) {
        valid = false;
      }
    });
    if (!valid) {
      this.snackbarService.open(
        'shared.snackbar.validationError',
        6,
        'failed'
      );
      return;
    }

    this.entity.name = this.kundeninformationen.value.name;
    this.entity.address.street = this.kundeninformationen.value.street;
    this.entity.address.postalCode = this.kundeninformationen.value.postalCode;
    this.entity.address.city = this.kundeninformationen.value.city;
    this.entity.address.country = this.kundeninformationen.value.country;
    this.entity.address.contact.name = this.kontaktperson.value.name;
    this.entity.address.contact.email = this.kontaktperson.value.email;
    this.entity.address.contact.phone = this.kontaktperson.value.phone;
    this.entity.address.contact.position = this.kontaktperson.value.position;

    const wizardDto = new CustomerWizardDto();

    wizardDto.customer = this.entity;
    wizardDto.address = this.entity.address;
    wizardDto.contact = this.entity.address.contact;
    wizardDto.licences = this.entity.licences;

    console.log(wizardDto.address);

    if (this.isNew) {
      this.customerService.createCustomer(wizardDto).subscribe(
        (res) => {
          this.snackbarService.open(
            'customer.edit.snackbar.created',
            4,
            'success'
          );
        },
        (error) => {
          this.snackbarService.open('shared.snackbar.error', 4, 'failed');
        }
      );
    } else {
      this.customerService.updateCustomer(wizardDto).subscribe(
        (res) => {
          this.snackbarService.open(
            'customer.edit.snackbar.updated',
            4,
            'success'
          );
        },
        (error) => {
          this.snackbarService.open('shared.snackbar.error', 4, 'failed');
        }
      );
    }
    this.dialogRef.close();
  }

  abort(): void {
    this.dialogRef.close();
  }

  addLicence(): void {
    this.entity.licences.push(new LicenceTableDto());
    console.log(this.entity.licences.length);
  }

  removeLicence(): void {
    this.entity.licences.splice(this.entity.licences.length - 1);
  }

  public moveToStep(step: number) {
    this.stepperIndex = step;
  }

  dateChanged(date: any, licence: any): void {
    console.log('haha');
  }
}
